import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'

export function stringToArray(str) {
  if (str === '' || str === null || str === undefined) {
    return []
  } else {
    return str.split(',').map(Number)
  }
}

export function arrayToString(arr) {
  if (arr.length === 0) {
    return ''
  } else {
    return arr.join(',')
  }
}

export const cleanAndJoin = (array = []) =>
  array.map(String).filter(Boolean).join(',')

export function FormatEmails({ emails, t, lightEntreList }) {
  const TooltipBox = withStyles((theme) => ({
    tooltip: {
      backgroundColor: 'white',
      color: 'rgb(42, 42, 42)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #00CED1',
      padding: 10
    }
  }))(Tooltip)

  if (emails?.length === 1) {
    return <span>{emails[0]}</span>
  }

  return (
    <div>
      <TooltipBox
        title={
          <React.Fragment>
            <div>
              {lightEntreList?.map((el, idx) => (
                <div
                  key={idx}
                  style={{
                    fontSize: '12px',
                    padding: '5px'
                  }}
                >
                  {el.firstname + ' ' + el.lastname}
                </div>
              ))}
            </div>
          </React.Fragment>
        }
      >
        <span
          style={{
            color: '#1976d2',
            cursor: 'pointer',
            textDecoration: 'underline'
          }}
        >
          {emails?.length + ' ' + t('employer.assignments.entrepreneurs')}
        </span>
      </TooltipBox>
    </div>
  )
}

export function FormatIndustries({ t, industryList }) {
  const TooltipBox = withStyles((theme) => ({
    tooltip: {
      backgroundColor: 'white',
      color: 'rgb(42, 42, 42)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #00CED1',
      padding: 10
    }
  }))(Tooltip)

  if (industryList?.length === 1) {
    return <span>{industryList[0]}</span>
  } else if (industryList?.length > 1) {
    return (
      <div>
        <span>{industryList[0]}</span>
        <br />
        <TooltipBox
          title={
            <React.Fragment>
              <div>
                {industryList?.slice(1).map((industry, idx) => (
                  <div
                    key={idx}
                    style={{
                      fontSize: '12px',
                      padding: '5px'
                    }}
                  >
                    {industry}
                  </div>
                ))}
              </div>
            </React.Fragment>
          }
        >
          <span
            style={{
              color: '#1976d2',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            + {industryList?.length - 1} {t('employer.assignments.more')}
          </span>
        </TooltipBox>
      </div>
    )
  } else {
    return null
  }
}

export function emailStringToArray(emailString) {
  if (!emailString) return []

  return emailString
    .split(',')
    .map((e) => e.trim())
    .filter((e) => e !== '')
}
